<mat-toolbar color="primary">
  <span>{{ "Registrer beholdning per {innfoeringsdato}" | translate: {innfoeringsdato: innfoeringsdato.value | plaindate} }}</span>
  <button mat-icon-button mat-dialog-close aria-label="Example icon-button with share icon">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<mat-stepper [linear]="true" #steg (animationDone)="stegskifteAnimasjonFerdig(steg)">
  <mat-step [stepControl]="modell.aksjenummerSkjemakontroller">
    <form [formGroup]="skjemagruppeStegA" #skjemaA="ngForm">
    <mat-dialog-content #skjemaKontainer>
      <div class="innføringsdato">
        <mat-form-field>
          <mat-label>{{ "Innføringsdato" | translate }}</mat-label>
          <input matInput [min]="minimumInnfoeringsdato" [matDatepicker]="innfoeringsdatoVelger" [formControl]="innfoeringsdato">
          <mat-datepicker-toggle matSuffix [for]="innfoeringsdatoVelger"/>
          <mat-datepicker #innfoeringsdatoVelger/>
          @if(innfoeringsdato.hasError('matDatepickerParse')){
            <mat-error data-testid="matDatepickerParse">{{ innfoeringsdato.errors | standardvalideringsfeil:'matDatepickerParse' }}</mat-error>
          }
          @if(innfoeringsdato.hasError('matDatepickerMin')){
            <mat-error data-testid="matDatepickerParse">{{ 'Første mulige dato er {minimumInnfoeringsdato}' | translate: {minimumInnfoeringsdato: minimumInnfoeringsdato | plaindate} }}</mat-error>
          }
          <!--<mat-hint align="start">Datoen den nye beholdningen er gjeldende fra</mat-hint>-->
        </mat-form-field>
        <tips>{{ "Bruk Innføringsdato til å angi datoen den nye beholdningen er gjeldende fra" | translate }}</tips>
      </div>
      <aksjeeiere-rediger-beholdning [modell]="modell"/>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainer" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
      <button mat-button mat-dialog-close>{{ "Avbryt" | translate }}</button>
      <button mat-raised-button type="submit" color="primary" cdkFocusInitial matStepperNext [disabled]="skjemaA.invalid || !skjemaA.dirty" data-testid="neste">{{ "Neste" | translate }}</button>
    </mat-dialog-actions>
    </form>
  </mat-step>

  <mat-step>
    <form (ngSubmit)="lagre()" [formGroup]="skjemagruppeStegB" #skjemaB="ngForm">
    <mat-dialog-content #bekreftKontainer>
      @if (modell.endredeBeholdninger().length == 1) {
        <h2>{{ "Bekreft oppdatering av 1 beholdning" | translate: {endredeBeholdninger: modell.endredeBeholdninger().length} }}</h2>
      } @else {
        <h2>{{ "Bekreft oppdatering av {endredeBeholdninger} beholdninger" | translate: {endredeBeholdninger: modell.endredeBeholdninger().length} }}</h2>
      }
      <aksjeeiere-bekreft-beholdning [modell]="modell" [innfoeringsdato]="innfoeringsdato.value!"/>
      <div class="endringsårsak">
        @if (!modell.inneholderEndringer()) {
          <inline-melding type="info">
            {{ "Ingen beholdninger er endret, ingen ting å lagre" | translate }}
          </inline-melding>
        } @else {
          <mat-form-field>
            <mat-label>{{ "Årsak til endringen" | translate }}</mat-label>
            <input matInput [formControl]="endringsaarsak" data-testid="endringsårsak" #endringsaarsakFelt>
            @if(endringsaarsak.hasError('maxlength')){
              <mat-error data-testid="maxlength">{{endringsaarsak.errors | standardvalideringsfeil:'maxlength' }}</mat-error>
            }
          </mat-form-field>
        }
      </div>
      @if (modell.inneholderEndringer()) {
        <tips class="bunntips">
          {{'Merk at stemmevekt registrert på stemmeberettigede i møter ikke automatisk blir oppdatert ved endringer i beholdning. Du må selv sørge for å redigere stemmevekt på aktuelle møter.'|translate}}
        </tips>
      }
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="bekreftKontainer" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
      <button mat-button matStepperPrevious>{{ "Tilbake" | translate }}</button>
      <button mat-raised-button type="submit" color="primary" cdkFocusInitial
              [disabled]="skjemaB.invalid || !modell.inneholderEndringer()" [visSpinner]="lagrer()" spinnerTekst="{{'Lagrer...'|translate}}"
              data-testid="lagre">{{ "Bekreft oppdatering" | translate }}</button>
    </mat-dialog-actions>
    </form>
  </mat-step>
</mat-stepper>
